interface State {
    recaptchaVerified: boolean
    recaptchaVerifiedTime: number
}

const defaults = () => {
    return {
        recaptchaVerified: false,
        recaptchaVerifiedTime: null
    }
}

export default {
    state: defaults(),
    mutations: {
        recaptchaVerifiedSet (state: State, success: boolean): void {
            state.recaptchaVerified = success
        },
        recaptchaVerifiedTime (state: State, time: number): void {
            state.recaptchaVerifiedTime = time
        }
    },
    actions: {
        verifyRecaptcha ({ commit }, token: string): Promise<boolean> {
            //  Construct our payload
            const payload = {'token' : token}

            //  Send the request
            return window.axios.post('auth/recaptcha', payload).then(response => {
                //  Set our new recaptcha verified to the API repsonse
                commit('recaptchaVerifiedSet', response.data)

                //  Set the new recaptcha verified time based on whether it was successful or not
                const time = response.data === true ? new Date() : null
                commit('recaptchaVerifiedTime', time)

                //  Return the time
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        recaptchaVerified (state: State): boolean {
            return state.recaptchaVerified
        },
        recaptchaVerifiedTime (state: State): number {
            return state.recaptchaVerifiedTime
        },
        showRecaptcha (_, getters): boolean {
            //  Check if we're running in a Native app
            const isNative = getters.isNativeApp

            //  Check if Recaptcha is enabled
            const isEnabled = process.env.VUE_APP_RECAPTCHA_ENABLED == 'true' ? true : false

            //  Check if we're running in test mode
            const isTest = window.Cypress

            //  Show recaptcha if it is enabled AND is NOT a native app AND is NOT a test
            const show = isEnabled && !isNative && !isTest

            //  Return the result
            return show
        }
    }
}